import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

const ProjectContext = createContext(null);
const KEY = "mori_active_project";

function read() {
  try {
    const v = localStorage.getItem(KEY);
    return v ? JSON.parse(v) : null;
  } catch {
    return null;
  }
}

export function ProjectProvider({ children }) {
  const { user, loading } = useAuth();
  const [activeProject, setState] = useState(read);

  const setActiveProject = useCallback((p) => {
    const slim = p ? { project_id: p.project_id, name: p.name, location: p.location } : null;
    setState(slim);
    try {
      if (slim) localStorage.setItem(KEY, JSON.stringify(slim));
      else localStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  }, []);

  const clearActiveProject = useCallback(() => setActiveProject(null), [setActiveProject]);

  // Clear the active project only once the session is confirmed closed
  // (not during the initial /auth/me check, when user is transiently null).
  useEffect(() => {
    if (!loading && !user) {
      setState(null);
      try { localStorage.removeItem(KEY); } catch { /* ignore */ }
    }
  }, [user, loading]);

  return (
    <ProjectContext.Provider value={{ activeProject, setActiveProject, clearActiveProject }}>
      {children}
    </ProjectContext.Provider>
  );
}

export const useActiveProject = () => useContext(ProjectContext);
